import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { ANDROID_URL } from '../constants/storeLinks';

export default function AnnouncementBanner() {
  const { t } = useTranslation();
  const [visible, setVisible] = useState(true);

  if (!visible) return null;

  return (
    <div className="bg-[#13C5C5] text-white text-sm font-semibold py-2 px-4 flex items-center justify-center gap-3 relative">
      <span>🎉</span>
      <span>{t('banner.text')}</span>
      <a
        href={ANDROID_URL}
        target="_blank"
        rel="noopener noreferrer"
        className="underline underline-offset-2 hover:text-white/80 transition-colors"
      >
        {t('banner.cta')}
      </a>
      <button
        onClick={() => setVisible(false)}
        aria-label="Dismiss"
        className="absolute right-4 top-1/2 -translate-y-1/2 text-white/70 hover:text-white transition-colors text-base leading-none"
      >
        ✕
      </button>
    </div>
  );
}
